export default "__VITE_ASSET__040567ea__"